import { Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { LazyLoading } from "../../../controls/LazyLoading/LazyLoading";
import { TableEmailTopics } from "./components/TableEmailTopics";
import { useEmailTopicsContext } from "./context/EmailTopicsContext";
import {
	getEmailAddresses,
	getEmailTopics,
} from "./repositories/EmailTopicsRepository";

export const EmailTopicsPage = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");
	const {
		actions: { setTopics, setAddresses, setAddressTopics },
	} = useEmailTopicsContext();

	const getEmailTopicsFromAPI = async () => {
		setIsLoading(true);
		try {
			const [topics, addresses] = await Promise.all([
				getEmailTopics(),
				getEmailAddresses(),
			]);
			setTopics(topics.topics);
			setAddressTopics(topics.addresses);
			setAddresses(addresses);
		} catch (e: any) {
			setError(e?.message || "Error fetching email topics");
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getEmailTopicsFromAPI();
	}, []);

	if (isLoading) {
		return (
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				style={{ height: "70vh", width: "100%" }}
			>
				<LazyLoading />
			</Grid>
		);
	}

	return (
		<Grid container justifyContent="center" alignItems="center">
			<ErrorModal error={error} onHide={() => setError("")} />
			<div style={{ width: "100%", padding: "10px 0 20px" }}>
				<TableEmailTopics
					isLoading={isLoading}
					getEmailTopicsFromAPI={getEmailTopicsFromAPI}
				/>
			</div>
		</Grid>
	);
};
